import { render } from "./EditCategoryModal.vue?vue&type=template&id=057f6324"
import script from "./EditCategoryModal.vue?vue&type=script&lang=js"
export * from "./EditCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\uat-frontend-saxton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__